import * as _ from 'lodash';
import graphActions from '../actions/GraphActions';
import { createReducer, ISuccessfulAction } from '../ReduxDecorators';
import { IActiveDirectoryUser, IHash, IActiveDirectoryGroup, IActiveDirectoryApp } from '@ane/core/lib/models';

export interface IGraphState {
  userGroupPermissions: { [groupNickName: string]: boolean };
  users: IHash<IActiveDirectoryUser>;
  groups: IHash<IActiveDirectoryGroup>;
  apps: IHash<IActiveDirectoryApp>;
  userImages: IHash<string>;
  appImages: IHash<string>;
}

const defaultState: IGraphState = {
  userGroupPermissions: {},
  users: {},
  groups: {},
  apps: {},
  userImages: {},
  appImages: {},
};

export class GraphReducer {
  public checkSecurityGroup(state: IGraphState, { payload }): IGraphState {
    const userGroupPermissions = _.clone(state.userGroupPermissions);
    userGroupPermissions[payload.group] = payload.isMember;
    return {
      ...state,
      userGroupPermissions,
    };
  }

  public getUser(state: IGraphState, payload: ISuccessfulAction<{ id: string; user: IActiveDirectoryUser }>): IGraphState {
    if (payload.payload) {
      return {
        ...state,
        users: {
          ...state.users,
          [payload.payload.id]: payload.payload.user,
        },
      };
    }
    return state;
  }

  public getGroup(state: IGraphState, payload: ISuccessfulAction<{ id: string; group: IActiveDirectoryGroup }>): IGraphState {
    if (payload.payload) {
      return {
        ...state,
        groups: {
          ...state.groups,
          [payload.payload.id]: payload.payload.group,
        },
      };
    }
    return state;
  }

  public getApp(state: IGraphState, payload: ISuccessfulAction<{ appId: string; app: IActiveDirectoryApp }>): IGraphState {
    if (payload.payload) {
      return {
        ...state,
        apps: {
          ...state.apps,
          [payload.payload.appId]: payload.payload.app,
        },
      };
    }
    return state;
  }

  public getUserImage(state: IGraphState, payload: ISuccessfulAction<{ upn: string; image: string }>): IGraphState {
    const userImages = {
      ...state.userImages,
      [payload.payload.upn]: payload.payload.image,
    };
    return {
      ...state,
      userImages,
    };
  }

  public getAppImage(state: IGraphState, payload: ISuccessfulAction<{ appId: string; image: string }>): IGraphState {
    const appImages = {
      ...state.appImages,
      [payload.payload.appId]: payload.payload.image,
    };
    return {
      ...state,
      appImages,
    };
  }
}

export default createReducer(graphActions, new GraphReducer(), defaultState);
